// KiraContext.jsx — global K.I.R.A state provider.
import React, { createContext, useContext } from "react";
import useKira from "../hooks/useKira";

const KiraContext = createContext(null);

export function KiraProvider({ children }) {
  const kira = useKira();
  return (
    <KiraContext.Provider value={kira}>
      {children}
    </KiraContext.Provider>
  );
}

export function useKiraContext() {
  const ctx = useContext(KiraContext);
  if (!ctx) {
    throw new Error("useKiraContext must be used inside <KiraProvider>");
  }
  return ctx;
}

export default KiraContext;
